import { useMemo } from 'react';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export type UseResponsiveProps = {
  isMobile: boolean;
  isXs: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

export const useResponsive = (): UseResponsiveProps => {
  const screens = useBreakpoint();

  const isXs = useMemo<boolean>(() => {
    return (screens.xs && !screens.sm) || false;
  }, [screens]);

  const isMobile = useMemo<boolean>(() => {
    return ((screens.xs || screens.sm) && !screens.md) || false;
  }, [screens]);

  const isTablet = useMemo<boolean>(() => {
    return ((screens.xs || screens.sm || screens.md) && !screens.lg) || false;
  }, [screens]);

  const isDesktop = useMemo<boolean>(() => {
    return screens.lg || screens.xl || screens.xxl || false;
  }, [screens]);

  return {
    isXs,
    isMobile,
    isTablet,
    isDesktop,
  };
};
